import { ButtonPrimary } from '@modules/common/components/form/buttons/button-primary';
import { useFormikContext } from 'formik';
import { handleGiftCardTypeSelection } from '../handles/handle-giftcard-type-selection';
import {
  giftCardTypesText,
  RESTAURANTS_DESCRIPTION,
} from '@lib/constants/gift-card-type-constants';
import { CARD_PROGRAMS } from '@lib/constants';
import { useEffect, useState } from 'react';
import letThemChooseUtil from '@lib/util/let-them-choose-util';

export const GiftCardTypes = () => {
  const [description, setDescription] = useState(RESTAURANTS_DESCRIPTION);
  const form = useFormikContext<any>();
  const field = form.getFieldProps('giftCardType');
  const [giftCardTypes, setGiftCardTypes] = useState<string[]>([]);

  const handleSelectionChange = (item: string) => {
    sessionStorage.setItem(CARD_PROGRAMS.KEY, item);
    setDescription(letThemChooseUtil.getDescription(item));
  };

  useEffect(() => {
    const getGiftCardTypes = async () => {
      const response = await letThemChooseUtil.getGiftCardTypes();
      setGiftCardTypes(response);
    }
    getGiftCardTypes();

    setTimeout(()=> {
      const cardProgram = sessionStorage.getItem(CARD_PROGRAMS.KEY) ?? CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT;
      setDescription(letThemChooseUtil.getDescription(cardProgram));
    }, 1000);
  }, []);

  return (
    <div>
      <div>
        The perfect gift when you're not quite sure what to give! With a Choose
        Your Own gift card, you set the amount and your recipient can select
        from over <b>{description}</b>. Your gift, their choice.
      </div>
      <div className="text-base text-black font-medium mb-2">Type:</div>
      <div className="card__method__items gap-1.5 flex flex-row flex-wrap">
        {giftCardTypes.map((item, _index) => (
          <div key={item}>
            <ButtonPrimary
              type="button"
              size="medium"
              active={field.value === item}
              onClick={() => {
                handleGiftCardTypeSelection({ item, field, form });
                handleSelectionChange(item);
              }}
              className="!py-1"
            >
              {giftCardTypesText[item] as string}
            </ButtonPrimary>
          </div>
        ))}
      </div>
    </div>
  );
};
